<template>
  <div
    :class="[
      'pill',
      info && 'pill--info',
      infoWhite && 'pill--info-white',
      succes && 'pill--succes',
      danger && 'pill--danger',
      warn && 'pill--warn',
      cart && 'pill--cart',
      nav && 'pill--nav',
      navSelected && 'pill--nav-selected',
    ]"
    @click="$emit('pill-click')"
  >
    <div class="pill__content">
      <div v-if="text" class="pill__text">
        {{ text }}
      </div>
      <slot v-else class="pill__text" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pill',
  emits: ['pill-click'],
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    info: {
      type: Boolean,
      required: false,
      default: false,
    },
    infoWhite: {
      type: Boolean,
      required: false,
      default: false,
    },
    succes: {
      type: Boolean,
      required: false,
      default: false,
    },
    danger: {
      type: Boolean,
      required: false,
      default: false,
    },
    warn: {
      type: Boolean,
      required: false,
      default: false,
    },
    cart: {
      type: Boolean,
      required: false,
      default: false,
    },
    nav: {
      type: Boolean,
      required: false,
      default: false,
    },
    navSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.pill {
  $this: &;
  color: var(--charcoal);
  font-weight: 450;
  font-size: rem(12px);
  line-height: 14px;
  padding: 5px 10px;
  border-radius: 30px;
  width: fit-content;
  background-color: var(--white);
  box-shadow: var(--box-shadow-lavender);
  @include desktop {
    display: inline-flex;
  }
  &__content {
    font-family: var(--font-regular);
  }
  &--info {
    background-color: var(--chetwode-blue);
  }
  &--info-white {
    background-color: var(--white);
  }
  &--succes {
    background-color: var(--strong-light-green);
    box-shadow: var(--box-shadow-strong-light-green);
  }
  &--danger {
    background-color: var(--red-pill);
    box-shadow: var(--box-shadow-red-pill);
  }
  &--warn {
    background-color: var(--light-orange);
    box-shadow: var(--box-shadow-orange);
  }
  &--cart {
    background: var(--purple-gradient);
    box-shadow: var(--purple-pale);
    color: var(--white);
    padding: 10px 15px;
  }
  &--nav {
    background: none;
    box-shadow: none;
    color: var(--light-blue-gray);
    padding: 10px 15px;
    transition: all 0.3s ease-in-out;
    white-space: nowrap;
    cursor: pointer;
    &-selected {
      color: var(--charcoal);
      background: var(--white);
      &:hover {
        color: var(--gray-7) !important;
        background: var(--white) !important;
      }
    }
    &:hover {
      color: var(--white);
      background: var(
        --mid-gray-translucid-gradient-two,
        linear-gradient(140deg, rgba(187, 188, 199, 0.7) 0%, rgba(187, 188, 199, 0) 100%)
      );
    }
  }
}
</style>
